import axios from "axios";

export const getAllUsers = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/users`);
};
